import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import React, { useState } from "react";
import icon2 from "../../../../../assets/images/Rounds/icons/finish 1.png";
import icon3 from "../../../../../assets/images/Rounds/icons/flag 1.png";
import icon1 from "../../../../../assets/images/Rounds/icons/Group 975.png";
import { DateTimePicker, LocalizationProvider } from "@mui/lab";
import { TextField } from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import moment from "moment";
import noImage from "../../../../../assets/images/settings/no-image.png";
import axios from "axios";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const Status2 = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { audition, auditionRoundRule, isAllStarResponsed, data, setData } = props;

  const history = useHistory();

  const [convertedContent, setConvertedContent] = useState(null);
  const [timeBoundery, setTimeBoundery] = useState(new Date());
  const [inputData, setInputData] = useState({
    error_list: [],
  });

  const [title, setTitle] = useState("");
  const [banner, setBanner] = useState("");
  const [video, setVideodata] = useState("");
  const [bannerfile, setBannerFile] = useState("");

  const handleBannerChange = (file) => {
    setBannerFile(URL.createObjectURL(file[0]));
    setBanner(file[0]);
  };

  const handleVideoChange = (file) => {
    setVideodata(file[0]);
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }



  const sendToManagerAdmin = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("audition_id", audition.id);
    formData.append("title", title);
    formData.append("description", convertedContent);
    formData.append("banner", banner);
    formData.append("video", video);
    formData.append("audition_round_rule_id", audition.audition_round_rules_id);
    formData.append(
      "uploade_date",
      moment(timeBoundery).format("yyyy-MM-DD HH:mm:ss")
    );

    axios.post(`/api/audition-admin/audition-round-instruction`, formData).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        history.push(`audition-admin/audition/event`);
      } else if (res.data.status === 422) {
        setInputData({
          ...inputData,
          error_list: res.data.validation_errors,
        });
      } else {
      }
    });
  };

  return (
    <div className="container my-3">
      <div style={{ border: "2px solid gold", borderRadius: "10px" }}>
        {isAllStarResponsed && isAllStarResponsed === true ? <> {auditionRoundRule && auditionRoundRule.status === 1 ? <><h1 className="text-danger">Already Instruction Send To Manager Admin</h1></> : <><div className="p-4">
          <h5 className="text-warning">Audition Instruction Title</h5>
          <div className="form-group row mt-3">
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control Frombtns"
                placeholder="Enter instruction title"
                // onChange={}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <span className="text-danger">{inputData.error_list.title}</span>
          </div>

          <section className="mt-4">
            <h5 className="text-warning">
              Audition Instruction Details
            </h5>
            <div className="form-group row mt-3">

              <div className="col-sm-8">
                <CKEditor
                  editor={ClassicEditor}
                  data={convertedContent}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setConvertedContent(data);
                  }}
                />
              </div>
              <span className="text-danger">
                {inputData.error_list.description}
              </span>
            </div>
          </section>

          <section>
            <div className="form-group row mt-3">
              <label
                for="staticEmail"
                className="col-sm-2 col-form-label text-light "
              >
                Upload File
              </label>

              <div className="col-sm-3 mb-2">
                <div className="row my-4">
                  <div className="col-md-5 text-white">
                    <img
                      src={bannerfile}
                      className="img-fluid avatar-img-src"
                      alt=""
                    />
                  </div>
                  <div className="col-md-7">
                    <input
                      type="file"
                      name="file"
                      id="setBannerFile"
                      className="inputfile w-25"
                      onChange={(e) => handleBannerChange(e.target.files)}
                    />

                    <label for="setBannerFile">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Banner
                    </label>
                    <span className="text-danger">
                      {inputData.error_list?.banner}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-sm-3 mb-2">
                <div className="row my-4">
                  <div className="col-md-10">
                    <input
                      type="file"
                      name="file"
                      id="setVideoFile"
                      className="inputfile w-25"
                      onChange={(e) => handleVideoChange(e.target.files)}
                    />

                    <label for="setVideoFile">
                      <i className="fas fa-cloud-upload-alt"></i> Upload Video
                    </label>
                    <span className="text-danger">
                      {inputData.error_list?.video}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="container d-sm-block d-md-flex justify-content-between">
            <div className="status-start d-flex mb-2">
              <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                <div>
                  <img src={icon3} className="statusImg" alt="" />
                </div>
              </div>
              <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                <div>
                  <small className="text-light">Starts</small>
                  <h5 className="text-light fontSizeStatus">
                    {moment(audition.start_time).format("LL")}
                  </h5>
                </div>
              </div>
            </div>

            <div className="status-start2 d-flex mb-2">
              <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                <div>
                  <img src={icon2} className="statusImg" alt="" />
                </div>
              </div>
              <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                <div>
                  <small className="text-light">Ends</small>
                  <h5 className="text-light fontSizeStatus">
                    {" "}
                    {moment(audition.end_time).format("LL")}
                  </h5>
                </div>
              </div>
            </div>

            <div className="status-start d-flex mb-2">
              <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                <div>
                  <img src={icon1} className="statusImg" alt="" />
                </div>
              </div>
              <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                <div>
                  <small className="text-light">Last Date Of Uploade</small>
                  <div className="col-sm-12">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        value={timeBoundery}
                        onChange={(getStartTime) => {
                          setTimeBoundery(getStartTime);
                        }}
                      />
                    </LocalizationProvider>
                    <span className="text-danger">
                      {inputData.error_list.uploade_date}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="star-cardColor my-3 p-2"
            style={{ borderRadius: "3px" }}
          >
            <div className="d-flex align-items-center">
              <h3 className="text-light">Who will judge you?</h3>
            </div>
          </section>

          <section className="d-sm-block d-md-flex justify-content-between">
            {audition.assigned_judges &&
              audition?.assigned_judges.map((judge, index) => (
                <div className="status-start2 d-flex mb-2">
                  <div className="img-icon-status  d-flex justify-content-center align-items-center ms-3">
                    <div>
                      <img
                        src={
                          judge.user?.image != null
                            ? imageCdnUrl + judge.user?.image
                            : noImage
                        }
                        height={"80px"}
                        width={"80px"}
                        className="statusImg"
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="img-icon-status  d-flex justify-content-center align-items-center mx-3">
                    <div>
                      <small className="text-light">
                        {capitalizeFirstLetter(judge.user?.user_type)}
                      </small>
                      <h5 className="text-light fontSizeStatus">
                        {judge.user?.first_name + " " + judge.user?.last_name}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
          </section>
          <section className="mt-5">
            <button
              className="w-100 btn btn-warning fw-bold"
              onClick={sendToManagerAdmin}
            >
              Approval Request for manager Admin
            </button>
          </section>
        </div></>}</> : <><h1 className="text-danger">Wating For All Judge Instruction Feedback.</h1></>}

      </div>
    </div>
  );
};

export default Status2;
